import styles from './CommonLoading.module.scss';

function CommonLoading() {
  return (
    <div className={styles.componentStyle}>
      <div className={styles.loader} />
    </div>
  );
}

export default CommonLoading;
